module.exports = __webpack_public_path__ + "img/gift_point_icon.ed7997f3.svg";